import { LitElement, html, css } from 'lit'

import { copyIcon } from '../../../../shared/assets/icons.js'

class CopyClick extends LitElement {
  static get properties() {
    return {}
  }
  static styles = css`
    svg {
      cursor: pointer;
    }

    :host {
      height: 24px;
    }

    .copy-wrap {
      height: 24px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 4px;
    }

    #copy-alert {
      display: none;
      align-items: flex-start;
      padding: 4px 16px 4px 16px;
      height: 24px;
      justify-content: center;
      align-items: center;
      border: none;
      border-radius: var(--small-border-radius);
      background: var(--grey);
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      z-index: 9999;
    }

    #copy-alert p {
      color: var(--Black, #f7f7f7);
      text-align: center;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 83.333% */
      letter-spacing: 0.024px;
    }

    .pop-up {
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    #arrow {
      display: none;
      position: relative;
      left: 50%;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid var(--grey);
      z-index: 9999;
    }
  `
  constructor() {
    super()
    this.value = undefined
  }

  connectedCallback() {
    super.connectedCallback()
  }

  handleClick() {
    const textToCopy = this.value ? this.value : this.textContent
    navigator.clipboard.writeText(textToCopy)

    this.showAlert()
  }

  showAlert() {
    /** @type {HTMLElement} */
    const dialogMessage = this.shadowRoot.querySelector('#copy-alert')
    /** @type {HTMLElement} */
    const arrow = this.shadowRoot.querySelector('#arrow')
    dialogMessage.style.display = 'flex'
    arrow.style.display = 'flex'

    setTimeout(() => {
      dialogMessage.style.display = 'none'
      arrow.style.display = 'none'
    }, 1000)
  }

  render() {
    return html`
      <span class="copy-wrap">
        <slot class="copy-text" id="copy">${this.textContent}</slot
        ><span @click=${this.handleClick}>${copyIcon}</span></span
      >
      <div class="pop-up">
        <div id="arrow"></div>
        <div id="copy-alert">
          <p>Text Copied</p>
        </div>
      </div>
    `
  }
}

customElements.define('copy-click', CopyClick)
export default CopyClick
